// import styled from "styled-components";
// import { ContainerStyle } from "../../style/Common.style";

// type NavbarStyleProps = {
//   isNavSticky: boolean;
// };

// export const NavbarStyle = styled.nav<NavbarStyleProps>`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   background: ${(props) => (props.isNavSticky ? "#fff" : "transparent")};
//   transition: all 200ms linear;
//   box-shadow: ${(props) =>
//     props.isNavSticky ? "0 1px 10px rgb(0 0 0 / 10%)" : "none"};
//   z-index: 100;
//   background: #fff;

//   &.active {
//     height: 100%;

//     .toggle-menu-bar {
//       &:first-child {
//         transform: translate(0px, 6px) rotate(45deg);
//       }

//       &:nth-child(2) {
//         display: none;
//       }

//       &:last-child {
//         transform: translateY(-3px) rotate(-45deg);
//       }
//     }
//   }

//   .menu-toggle-button {
//     background: none;
//     border: 0;
//     margin: 0;
//     display: inline-flex;
//     flex-direction: column;
//     outline: none;

//     .toggle-menu-bar {
//       transition: all 300ms linear;
//       width: 30px;
//       height: 3px;
//       border-radius: 1.6px;
//       margin-top: 6.4px;
//       background: #000;

//       &:first-child {
//         margin-top: 0;
//       }
//     }

//     @media (min-width: 768px) {
//       display: none;
//     }
//   }

//   .navbar-wrapper {
//     ${ContainerStyle};

//     padding: 7px 15px;
//     position: relative;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;

//     @media (max-width: 768px) {
//       padding-left: 15px;
//       padding-right: 15px;
//     }
//   }

//   /* ✅ LOGO SIZE CONTROL (NEW ADDITION) */
//   .site-logo {
//     height: 60px;
//     width: auto;
//     max-width: 220px;
//     object-fit: contain;
//   }

//   .nav-links {
//     display: flex;

//     &.desktop {
//       @media (max-width: 768px) {
//         display: none;
//       }
//     }

//     &.mobile {
//       max-height: 0;
//       overflow: hidden;
//       transition: all 200ms linear;
//       display: grid;
//       justify-content: center;
//       grid-row-gap: 25px;
//       background: #fff;
//       padding: 0px;

//       @media (min-width: 768px) {
//         display: none;
//       }

//       &.active {
//         max-height: 100vh;
//         padding: 20px;
//       }

//       .link-wrapper {
//         text-align: center;

//         a {
//           color: #696A6D;
//           font-weight: 500;
//           font-size: 14px;
//           transition: all 200ms linear;

//           &:hover {
//             color: #000;
//           }
//         }
//       }
//     }

//     .link-wrapper {
//       margin: 0 10px;

//       a {
//         color: #696A6D;
//         transition: all 200ms linear;

//         &:hover {
//           color: #000;
//         }

//         &.active {
//           color: #CB1E0A;
//           position: relative;

//           &:after {
//             content: "";
//             position: absolute;
//             bottom: -5px;
//             left: 0;
//             width: 100%;
//             height: 2px;
//             background: #CB1E0A;
//           }

//           @media (max-width: 768px) {
//             color: #CB1E0A;
//           }
//         }
//       }
//     }
//   }

//   .contact {
//     display: flex;
//     align-items: center;
//     gap: 20px;
//   }
// `;

// Updated style ***

import styled from "styled-components";
import { ContainerStyle } from "../../style/Common.style";

type NavbarStyleProps = {
  isNavSticky: boolean;
};

export const NavbarStyle = styled.nav<NavbarStyleProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  transition: all 0.25s ease;
  box-shadow: ${(props) =>
    props.isNavSticky ? "0 8px 24px rgb(0 0 0 / 8%)" : "0 2px 10px rgb(0 0 0 / 4%)"};
  z-index: 100;

  &.active {
    height: 100%;

    .toggle-menu-bar {
      &:first-child {
        transform: translate(0px, 6px) rotate(45deg);
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:last-child {
        transform: translateY(-6px) rotate(-45deg);
      }
    }
  }

  .navbar-wrapper {
    ${ContainerStyle};
    padding: 10px 15px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 18px;

    @media (max-width: 768px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .branding-logo {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .site-logo {
    height: 62px;
    width: auto;
    max-width: 220px;
    object-fit: contain;

    @media (max-width: 768px) {
      height: 52px;
      max-width: 180px;
    }
  }

  .menu-toggle-button {
    background: none;
    border: 0;
    margin: 0;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    outline: none;
    padding: 0;
    cursor: pointer;

    .toggle-menu-bar {
      transition: all 300ms ease;
      width: 28px;
      height: 3px;
      border-radius: 2px;
      margin-top: 5px;
      background: #08182f;

      &:first-child {
        margin-top: 0;
      }
    }

    @media (min-width: 768px) {
      display: none;
    }
  }

  .nav-links {
    display: flex;
    align-items: center;

    &.desktop {
      gap: 4px;

      @media (max-width: 992px) {
        gap: 0;
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    &.mobile {
      max-height: 0;
      overflow: hidden;
      transition: all 0.25s ease;
      display: grid;
      justify-content: center;
      grid-row-gap: 18px;
      background: #ffffff;
      padding: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.06);

      @media (min-width: 768px) {
        display: none;
      }

      &.active {
        max-height: 100vh;
        padding: 24px 20px 28px;
      }

      .link-wrapper {
        text-align: center;

        a {
          color: #5f6670;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.2s ease;

          &:hover {
            color: #ff8500;
          }

          &.active {
            color: #cb1e0a;
          }
        }
      }
    }

    .link-wrapper {
      margin: 0 6px;

      @media (max-width: 992px) {
        margin: 0 2px;
      }

      a {
        color: #5f6670;
        transition: all 0.2s ease;
        font-size: 15px;
        font-weight: 600;
        position: relative;
        padding: 10px 8px;
        display: inline-flex;
        align-items: center;

        &:hover {
          color: #ff8500;
        }

        &.active {
          color: #cb1e0a;
        }

        &.active::after {
          content: "";
          position: absolute;
          bottom: 2px;
          left: 8px;
          width: calc(100% - 16px);
          height: 2px;
          background: #cb1e0a;
          border-radius: 999px;
        }
      }
    }
  }

  .contact {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    flex-shrink: 0;

    @media (max-width: 992px) {
      display: none;
    }

    a {
      background: #ff8500;
      color: #08182f;
      font-weight: 700;
      font-size: 15px;
      padding: 12px 18px;
      border-radius: 10px;
      box-shadow: 0 10px 24px rgba(255, 133, 0, 0.18);

      &:hover {
        background: #cb1e0a;
        color: #ffffff;
      }
    }
  }
`;


